import {togglePageLoader } from "store/actions"
import { call, put, takeEvery } from "redux-saga/effects"
import toast from "toastr"

// Login Redux States

import { get_user_list, update_attendance_details, update_timesheet_details, update_penalty_points, update_bulk_upload, update_new_user, get_user_devices, set_primary_device } from "helpers/backend_helper"
import { ADD_NEW_USER, BULK_UPLOAD, UPDATE_ATTENDANCE, UPDATE_TIMESHEET, UPDATE_PENALTY, UPDATE_NEW_USER, USER_DATA, GET_USER_DEVICES, SET_PRIMARY_DEVICE } from "./actiontype"
import { onAddnewUserError, onAddnewUserSuccess, onupdateUserError, onupdateUserSuccess, postuploadDataError, postuploadDataSuccess, userListError, userListSuccess, allUserListSuccess, getUserDevicesError, getUserDevicesSuccess, setPrimaryDeviceError, setPrimaryDeviceSuccess } from "./action"
import { add_new_user } from "helpers/backend_helper"

function* getUsersList({ payload: params }) {
  try {
    const response = yield call(get_user_list,params)
    if(params === undefined && response.statusCode===200){
      yield put(allUserListSuccess(response));
    }
    else if(response.statusCode===200){
      yield put(userListSuccess(response));
    }
    else {     
      yield put(userListError(response));
      toast.error(response.message)
    }
  } catch (error) {
    yield put(userListError(error));
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }

}
function* createnewuser({ payload: params,callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(add_new_user,params)
    if(response.statusCode===200){
      yield put(onAddnewUserSuccess(response));
      yield put(togglePageLoader(false))
      toast.success(response.message)
      callback("SUCCESS");
    }
    else {     
      yield put(onAddnewUserError(response));
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onAddnewUserError(error));
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}
function* updatenewUser({ payload: data,callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_new_user,data)
    if(response.statusCode===200){
      yield put(onupdateUserSuccess(response));
      yield put(togglePageLoader(false))
      toast.success(response.message)
      callback("SUCCESS");
    }
    else {
      yield put(onupdateUserError(response));
      toast.error(response.message)
      yield put(togglePageLoader(false))
      callback("FAILURE");
    }
  } catch (error) {
    yield put(onAddnewUserError(error));
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}
function* bulkupload({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_bulk_upload,data)
    if(response.statusCode===200){
      yield put(postuploadDataSuccess(response));
      yield put(togglePageLoader(false))
      toast.success(response.message)
      callback("SUCCESS");
    }
    else {
      yield put(postuploadDataError(response));
      toast.error(response.message)
      yield putglePageLoader(false)
      callback("FAILURE");
    }
  } catch (error) {
    yield put(postuploadDataError(error));
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}

function* updateAttendance({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_attendance_details,data)
    if(response.statusCode===200){
      yield put(togglePageLoader(false))
      toast.success(response.message);
      callback();
    }
    else {
      yield put(postuploadDataError(response));
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}

function* updateTimesheet({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_timesheet_details,data)
    if(response.statusCode===200){
      yield put(togglePageLoader(false))
      toast.success(response.message);
      callback();
    }
    else {
      yield put(postuploadDataError(response));
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}

function* updatePenalty({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(update_penalty_points,data)
    if(response.statusCode===200){
      yield put(togglePageLoader(false))
      toast.success(response.message || "Penalty points updated successfully");
      callback();
    }
    else {
      yield put(postuploadDataError(response));
      toast.error(response.message)
      yield put(togglePageLoader(false))
    }
  } catch (error) {
    toast.error(error?.response ? error.response?.data?.message :error)
    yield put(togglePageLoader(false))
  }
}

function* getUserDevicesList({ payload: userid, callback }) {
  try {
    const response = yield call(get_user_devices, userid)
    if (response.statusCode === 200) {
      yield put(getUserDevicesSuccess(response))
      if (callback) callback("SUCCESS", response)
    } else {
      yield put(getUserDevicesError(response))
      toast.error(response.message)
      if (callback) callback("FAILURE")
    }
  } catch (error) {
    yield put(getUserDevicesError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
  }
}

function* setPrimaryDeviceSaga({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true))
    const response = yield call(set_primary_device, data)
    if (response.statusCode === 200) {
      yield put(setPrimaryDeviceSuccess(response))
      yield put(togglePageLoader(false))
      toast.success(response.message)
      if (callback) callback("SUCCESS")
    } else {
      yield put(setPrimaryDeviceError(response))
      toast.error(response.message)
      yield put(togglePageLoader(false))
      if (callback) callback("FAILURE")
    }
  } catch (error) {
    yield put(setPrimaryDeviceError(error))
    toast.error(error?.response ? error.response?.data?.message : error)
    yield put(togglePageLoader(false))
    if (callback) callback("FAILURE")
  }
}

function* userlistage() {
  yield takeEvery(USER_DATA, getUsersList)
  yield takeEvery(ADD_NEW_USER, createnewuser)
  yield takeEvery(UPDATE_NEW_USER, updatenewUser)
  yield takeEvery(BULK_UPLOAD, bulkupload)
  yield takeEvery(UPDATE_ATTENDANCE, updateAttendance)
  yield takeEvery(UPDATE_TIMESHEET, updateTimesheet)
  yield takeEvery(UPDATE_PENALTY, updatePenalty)
  yield takeEvery(GET_USER_DEVICES, getUserDevicesList)
  yield takeEvery(SET_PRIMARY_DEVICE, setPrimaryDeviceSaga)
}

export default userlistage